module.exports = __webpack_public_path__ + "img/control.7667f709.svg";